function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import TmLabel from "./TmLabel";
import { AvGroup } from "availity-reactstrap-validation";
import TmFeedback from "./TmFeedback";
import TmHelpMessage from "./TmHelpMessage";
import { InputGroup, InputGroupAddon } from "reactstrap";

class TmField extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderPrepend", () => {
      if (this.props.prepend) {
        return /*#__PURE__*/React.createElement(InputGroupAddon, {
          addonType: "prepend"
        }, this.props.prepend);
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null);
    });

    _defineProperty(this, "renderAppend", () => {
      if (this.props.append) {
        return /*#__PURE__*/React.createElement(InputGroupAddon, {
          addonType: "append"
        }, this.props.append);
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null);
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(AvGroup, {
        cypress: `${this.props.cypress}Group`
      }, /*#__PURE__*/React.createElement(TmLabel, this.props), /*#__PURE__*/React.createElement(InputGroup, null, this.renderPrepend(), this.props.children, this.renderAppend()), /*#__PURE__*/React.createElement(TmFeedback, this.props), /*#__PURE__*/React.createElement(TmHelpMessage, this.props));
    });
  }

}

export default TmField;